interface OpsErrorRow {
  time: string
  level: string
  scope: string
  property_id: string
  category: string
  message: string
  correlation_id: string
}

export function OpsErrorsCard({
  rows,
  loading,
  onCopy,
  onOpenProperty,
}: {
  rows: OpsErrorRow[]
  loading: boolean
  onCopy: (value: string) => void
  onOpenProperty: (propertyId: string) => void
}) {
  return (
    <div className="section-card" style={{ padding: 0, overflow: "hidden" }}>
      <div className="ops-card-header">
        <div className="section-card__title" style={{ marginBottom: 0 }}>Recent Errors</div>
      </div>

      {loading ? (
        <div style={{ padding: "var(--sf-space-8)", textAlign: "center" }}>
          <div className="sf-spinner" style={{ margin: "0 auto" }} />
        </div>
      ) : rows.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state__title">No recent errors</div>
        </div>
      ) : (
        <div className="data-table-wrapper">
          <table className="data-table data-table--compact">
            <thead>
              <tr>
                <th>Time</th>
                <th>Scope</th>
                <th>Category</th>
                <th>Message</th>
                <th>Correlation ID</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, index) => (
                <tr key={`${row.time}-${index}`}>
                  <td>{formatTime(row.time)}</td>
                  <td>
                    {row.scope === "property" && row.property_id ? (
                      <button
                        type="button"
                        className="data-table__action"
                        onClick={() => onOpenProperty(row.property_id)}
                      >
                        property
                      </button>
                    ) : (
                      "system"
                    )}
                  </td>
                  <td>{row.category || "system"}</td>
                  <td className="ops-error-snippet">{row.message || "—"}</td>
                  <td>
                    {row.correlation_id ? (
                      <button
                        type="button"
                        className="data-table__action"
                        onClick={() => onCopy(row.correlation_id)}
                      >
                        Copy
                      </button>
                    ) : (
                      "—"
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

function formatTime(value: string) {
  if (!value) return "—"
  const ts = Date.parse(value)
  if (!Number.isFinite(ts)) return value
  return new Date(ts).toLocaleString()
}
